import { DEMOGRAPHIC_TYPE_TO_LABEL } from 'screens/WidgetGenerator/utils/misc';
import { DemographicType } from 'types/communitySurveyScores';

export const getDemographicLabel = (type: DemographicType): string => DEMOGRAPHIC_TYPE_TO_LABEL[type] ?? type;
